import { batchType, languageType } from "../components/updateTranslation/updateTranslationType";
import { updateRequestBody } from "../features/updateMetaConfig/UpdateMetaConfigTypes";
import { languageOptions } from "../types";
import { ChannelkartNetworkDelete, ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";

export async function getClientConfiguartions(configName : string){
    try {
        const response = await ChannelkartNetworkGet(`/metadata/clientconfig?name=${configName}`);
        return response;
    } catch (error) {
        return error
    }
}

export async function getTranslationForEachLanguage(languageArr: languageType[],componentName:string){
    try {
        const languageFilterArray = languageArr.map((languageObj) => languageObj.code);
        let filter = "?filter=translationLanguage[in]:[" + languageFilterArray + "]";
        if(componentName!=="all") filter += (" and component:" + componentName);
        const url = `/v1/translations${filter}&size=10000`;
        const response = await ChannelkartNetworkGet(url);
        return response.data.features;
    } catch (error) {
        
    }
}

export async function addTranslationRequestService(
    reqObj : batchType
  ) {
    const url = "/v1/translations/batch";
    const response = await ChannelkartNetworkPost(url, reqObj);
    return response;
  }

export async function getComponetOptions() {
    try {
      const response = await ChannelkartNetworkGet('/SPA/config/component.json');
      return response;
    } catch (error) {
      
    }
}

export async function deleteSingleTranslation(id : string)  {
    const url = `/v1/translations/${id}`;
    const response = await ChannelkartNetworkDelete(url);
    return response;
  };